import { render } from "./LineWithRibsPart.vue?vue&type=template&id=69d44b72"
import script from "./LineWithRibsPart.vue?vue&type=script&lang=js"
export * from "./LineWithRibsPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__